<template>
  <div class="reset-password-page">
    <h1>Reset Your Password</h1>

    <!-- Token missing -->
    <p v-if="!token" class="error">
      Invalid or missing reset token. Please check your link.
    </p>

    <!-- Success message -->
    <p v-if="success" class="success">{{ success }}</p>

    <!-- Error message -->
    <p v-if="error" class="error">{{ error }}</p>

    <!-- Form only when token present and no success yet -->
    <form
      v-if="token && !success"
      @submit.prevent="onSubmit"
      class="form"
    >
      <div class="form-group">
        <label for="password">New Password</label>
        <input
          id="password"
          type="password"
          v-model.trim="password"
          required
          minlength="6"
          placeholder="At least 6 characters"
        />
      </div>

      <div class="form-group">
        <label for="confirm">Confirm Password</label>
        <input
          id="confirm"
          type="password"
          v-model.trim="confirmPassword"
          required
          minlength="6"
          placeholder="Re-enter new password"
        />
      </div>

      <button
        type="submit"
        :disabled="loading"
        class="action-button primary"
      >
        {{ loading ? 'Saving…' : 'Save New Password' }}
      </button>
    </form>
  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'ResetPassword',
  data() {
    return {
      token: this.$route.query.token || '',
      password: '',
      confirmPassword: '',
      loading: false,
      error: '',
      success: ''
    };
  },
  methods: {
    async onSubmit() {
      this.error = '';
      if (this.password !== this.confirmPassword) {
        this.error = 'Passwords do not match.';
        return;
      }
      this.loading = true;
      try {
        const { data } = await api.post('/auth/reset-password', {
          token: this.token,
          password: this.password
        });
        this.success = data.message || 'Your password has been reset. You may now log in.';
      } catch (err) {
        this.error =
          err.response?.data?.error ||
          'Failed to reset password. The link may have expired or is invalid.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.reset-password-page {
  max-width: 400px;
  margin: 3rem auto;
  padding: 1rem;
  font-family: var(--font-sans, Arial, sans-serif);
}

h1 {
  text-align: center;
  margin-bottom: 1.5rem;
}

.form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

input {
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  border: 1px solid var(--color-muted, #ccc);
  border-radius: 4px;
}

button {
  padding: 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.action-button.primary {
  background-color: var(--color-accent, #3b82f6);
  color: #fff;
  margin-top: 0.5rem;
}

.error {
  color: var(--color-danger, #dc2626);
  margin: 1rem 0;
}

.success {
  color: var(--color-success, #16a34a);
  margin: 1rem 0;
}
</style>
